// extracted by mini-css-extract-plugin
export default {"message":"chat-view_message__N4DPQ","tableScroll":"chat-view_tableScroll__PFE7F","input":"chat-view_input__oIDTW"};